import { useState } from "react";
import { Search } from "lucide-react";
import { CATEGORIES } from "@/data/categories";
import CategoryCard from "@/components/CategoryCard";
import BrandsMarquee from "@/components/BrandsMarquee";

export default function Products() {
  const [q, setQ] = useState("");
  const filtered = CATEGORIES.filter((c) => {
    const t = q.trim().toLowerCase();
    if (!t) return true;
    return (
      c.name.toLowerCase().includes(t) ||
      c.tagline.toLowerCase().includes(t) ||
      c.description.toLowerCase().includes(t) ||
      c.items.some((i) => i.toLowerCase().includes(t)) ||
      c.brands.some((b) => b.toLowerCase().includes(t))
    );
  });

  return (
    <main data-testid="products-page" className="mx-auto max-w-7xl px-4 md:px-6 lg:px-8">
      <section className="pt-16 md:pt-24 pb-8">
        <div className="text-xs uppercase tracking-widest text-slate-500">Product Categories</div>
        <div className="grid md:grid-cols-12 gap-8 items-end mt-2">
          <h1 className="md:col-span-8 font-display text-4xl md:text-5xl lg:text-6xl font-extrabold tracking-tighter leading-[1.05]">
            17 categories, <span className="gfe-gradient-text">infinite possibilities.</span>
          </h1>
          <div className="md:col-span-4">
            <div className="relative">
              <Search className="w-4 h-4 absolute left-4 top-1/2 -translate-y-1/2 text-slate-400" />
              <input
                data-testid="products-search"
                value={q}
                onChange={(e) => setQ(e.target.value)}
                placeholder="Search category, brand, item…"
                className="w-full pl-10 pr-4 py-3 rounded-full border border-slate-200 bg-white text-sm focus:outline-none focus:ring-2 focus:ring-slate-900/5 focus:border-slate-400"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="pb-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5 md:gap-6">
          {filtered.map((c, i) => <CategoryCard key={c.slug} cat={c} index={i} />)}
        </div>
        {filtered.length === 0 && (
          <div className="text-center py-20 text-slate-500" data-testid="products-empty">No categories match &quot;{q}&quot;.</div>
        )}
      </section>

      <div className="-mx-4 md:-mx-6 lg:-mx-8">
        <BrandsMarquee />
      </div>
    </main>
  );
}
